import {ManholeGeometry} from "../../Verification/Lid/GroundView/manholeGeometry";
import React from "react";
import {Line} from "../primitives";

export const renderSplitLines = (manholeGeometry: ManholeGeometry) => {
    return [
        0,
        ...manholeGeometry.verticalClosureIntersectionsX
    ]
        .map((p, i) =>
            ({
                ...renderSplitLine(p, 0,  manholeGeometry.closureWidth, manholeGeometry.closureHeight),
                key: i,
            })
        )
}

export const renderSplitLine = (x: number, y: number, width: number, height: number) => {
    const xInset = 0.07 * width;
    const yInset = 0.05 * height;
    const x1 = x + xInset, y1 = y;
    const x2 = x1, y2 = y1 + yInset;
    const x3 = x + width - xInset, y3 = height - yInset;
    const x4 = x3, y4 = height;

    return (
        <React.Fragment>
            <Line points={[x1, y1, x2, y2]}/>
            <Line points={[x2, y2, x3, y3]}/>
            <Line points={[x3, y3, x4, y4]}/>
        </React.Fragment>
    )
}
